module.exports = __webpack_public_path__ + "media/bgm2.20279e2c.mp3";